const COURSE_QUERY =
`query course( $courseId: UUID! ) {
    course( courseID: $courseId ) {
        enrollment {
            status
            rating
            review
            userCertificate {
                id
                userCertificateUrl
                courseCertificate {
                    id
                    brand {
                        id
                    }
                }
            }
        }
        node {
            id
            locales {
                locale
                name
                description
            }
            heroImage {
                id
                url
            }
            thumbnailImage {
                id
                url
            }
            tags
            tagIds
            courseCertificates {
                id
                brand {
                    id
                }
            }
            ratingAverage
            curriculumIds
            ratingCount
            isSequential
            resourceIds
            learningObjects {
                edges {
                    assignment {
                        status
                        scormState
                        startedAt
                        completedAt
                    }
                    node {
                        id
                        locales {
                            locale
                            name
                            description
                        }
                        duration
                        expireAt
                        format
                        content {
                            id
                            url
                            lxpFileId
                            mimetype
                        }
                    }
                }
            }
            segmentIds
            categoryIds
            metadata
        }
    }
}`;
    
 const getCourseQuery = ( options = {} ) => {
    const result = {
        query: COURSE_QUERY,
        operationName: 'course',
        variables: { ...options }
    };

    return JSON.stringify( result );
};

export default getCourseQuery;
